import { UserProfile } from '../../domain/models/user.model';
import {
  CreateUserProfile,
  CreateUserProfileFailure,
  CreateUserProfilePayload,
  CreateUserProfileSuccess,
  CREATE_USER_PROFILE,
  CREATE_USER_PROFILE_FAILURE,
  CREATE_USER_PROFILE_SUCCESS,
  DeleteUserProfile,
  DeleteUserProfileFailure,
  DeleteUserProfilePayload,
  DeleteUserProfileSuccess,
  DELETE_USER_PROFILE,
  DELETE_USER_PROFILE_FAILURE,
  DELETE_USER_PROFILE_SUCCESS,
  GetUserProfile,
  GetUserProfileFailure,
  GetUserProfilePayload,
  GetUserProfileSuccess,
  GET_USER_PROFILE,
  GET_USER_PROFILE_FAILURE,
  GET_USER_PROFILE_SUCCESS,
  SetUserError,
  SET_USER_ERROR,
  UpdateUserProfile,
  UpdateUserProfileFailure,
  UpdateUserProfilePayload,
  UpdateUserProfileSuccess,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_FAILURE,
  UPDATE_USER_PROFILE_SUCCESS,
} from './user.action.type';

export const getUserProfile = (
  payload: GetUserProfilePayload,
): GetUserProfile => ({
  type: GET_USER_PROFILE,
  payload,
});

export const getUserProfileSuccess = (
  userProfile: UserProfile,
): GetUserProfileSuccess => ({
  type: GET_USER_PROFILE_SUCCESS,
  payload: userProfile,
});

export const getUserProfileFailure = (
  error: string,
): GetUserProfileFailure => ({
  type: GET_USER_PROFILE_FAILURE,
  payload: error,
});

export const createUserProfile = (
  payload: CreateUserProfilePayload,
): CreateUserProfile => ({
  type: CREATE_USER_PROFILE,
  payload,
});

export const createUserProfileSuccess = (
  userProfile: UserProfile,
): CreateUserProfileSuccess => ({
  type: CREATE_USER_PROFILE_SUCCESS,
  payload: userProfile,
});

export const createUserProfileFailure = (
  error: string,
): CreateUserProfileFailure => ({
  type: CREATE_USER_PROFILE_FAILURE,
  payload: error,
});

export const updateUserProfile = (
  payload: UpdateUserProfilePayload,
): UpdateUserProfile => ({
  type: UPDATE_USER_PROFILE,
  payload,
});

export const updateUserProfileSuccess = (
  userProfile: UserProfile,
): UpdateUserProfileSuccess => ({
  type: UPDATE_USER_PROFILE_SUCCESS,
  payload: userProfile,
});

export const updateUserProfileFailure = (
  error: string,
): UpdateUserProfileFailure => ({
  type: UPDATE_USER_PROFILE_FAILURE,
  payload: error,
});

export const setUserError = (error: string): SetUserError => ({
  type: SET_USER_ERROR,
  payload: error,
});

export const deleteUserProfile = (
  payload: DeleteUserProfilePayload,
): DeleteUserProfile => ({
  type: DELETE_USER_PROFILE,
  payload,
});

export const deleteUserProfileSuccess = (): DeleteUserProfileSuccess => ({
  type: DELETE_USER_PROFILE_SUCCESS,
  payload: undefined,
});

export const deleteUserProfileFailure = (
  error: string,
): DeleteUserProfileFailure => ({
  type: DELETE_USER_PROFILE_FAILURE,
  payload: error,
});
